module.exports = __webpack_public_path__ + "static/img/1.18a9fdf.png";


//////////////////
// WEBPACK FOOTER
// ./static/hz/1.png
// module id = 61/I
// module chunks = 202